const staffRankManagement = () =>
  import('@/views/main/staff/rank-management/rank-management.vue')
export default {
  path: '/main/staff/rankManagement',
  name: 'staffRankManagement',
  component: staffRankManagement,
  children: []
}
